module.exports = __webpack_public_path__ + "img/inscribete.a0b1ad3e.jpg";